<template>
  <section class="standard">
    <!-- <com-tabs
      :list="tabsList"
      class="standard-tabs"
      :default-tab="activeTab"
      @change="changeTab"
    >
      <template v-slot:text="{ obj }">
        <div
          :class="{ activeTab: activeTab == obj.key }"
          class="standard-tabs-item"
        >
          <span>
            <img
              :src="require(`@/assets/dto/dto-standard${obj.key + 1}.png`)"
              alt=""
            >
          </span>
          <span>{{ obj.name }}</span>
        </div>
      </template>
    </com-tabs> -->
    <Tbs
      @filter="filterGetData"
    />
    <div v-loading.fullscreen.lock="loading" class="standard-content">
      <com-table
        :data="tableData"
        :configs="standardInfo.obj.table"
        :is-route-dto="true"
        is-route-dto-str="article_name"
        @path="handleRouteDto1"
      >
        <template v-slot:operate="{ row }">
          <el-button type="text" @click="handleRouteDto(row)">
            查看
          </el-button>
          <span class="pad-row4">/</span>
          <el-button type="text" @click="handleControl(row)">
            {{
              row.is_collection == 1 ? "取消收藏" : "收藏"
            }}
          </el-button>
        </template>
      </com-table>
    </div>
    <div class="p-contianer">
      <el-pagination
        :current-page="requestParams.page"
        :page-size.sync="requestParams.page_size"
        :page-sizes="pageSizes"
        :total="total"
        :pager-count="5"
        class="p-bar"
        background
        layout="prev, pager, next,sizes, total, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
    <div v-if="dialogVisible">
      <el-dialog
        title="标准详情"
        :visible.sync="dialogVisible"
        :fullscreen="true"
        class="fullscreenDialog"
      >
        <StandardDetails
          :row-id="rowId" />
      </el-dialog>
    </div>
  </section>
</template>


<script>
import api from '@/api/app'
import mock from '@/utils/mock'
// import comTabs from '@/components/comTabs'
import Tbs from './Tbs'
import comTable from '@/components/comTable'
import StandardDetails from '@/views/notes/standard/details'

export default {
  components: {
    // comTabs,
    Tbs,
    comTable,
    StandardDetails
  },
  data() {
    return {
      tabsList: [],
      tableData: [],
      data1: null,
      standardInfo: mock.notes.standard.viewInfo,
      standardInit: mock.notes.standard.init,
      total: null,
      activeTab: 0,
      requestParams: {
        page: 1,
        page_size: 20,
        search: '',
        type: '',
        category_id: ''
      },
      requestParams1: {
        collection_id: null,
        collection_type: 1
      },
      loading: false,
      pageSizes: [20, 30, 60, 100],
      rowId: null,
      dialogVisible: false
    }
  },
  computed: {
    conditionTitle() {
      return `共有${this.total}套标准`
    },
    category() {
      return this.$route.query.category
    }
  },
  watch: {
    category(val, oldVal) {
      if (val) {
        this.dialogVisible = false
        this.initType()
      }
    }
  },
  created() {
    this.initType()
    // this.init(this.requestParams)
  },
  mounted() {},
  methods: {
    control(type, condition) {
      return mock.system.global.control[type](condition)
    },
    async initType() {
      // this.tabsList = await this.standardInit.types()
      // this.requestParams.category_id = this.tabsList[0].id}
      this.requestParams.category = this.category || ''
      this.init(this.requestParams)
    },
    async init(v) {
      this.loading = true
      const obj = await this.standardInit.data(v)
      this.tableData = obj.data
      this.total = obj.total
      this.loading = false
    },
    handleControl(v) {
      this.requestParams1.collection_id = v.id
      if (v.is_collection == 1) {
        this.$confirm('确认取消收藏吗?', '提示', {})
          .then(() => {
            api.mine.delete.collect(this.requestParams1).then((res) => {
              this.$message.success('取消收藏成功')
              this.init(this.requestParams)
            })
          })
          .catch(() => {})
      } else {
        this.$confirm('确认收藏吗?', '提示', {})
          .then(() => {
            api.mine.create.collect(this.requestParams1).then((res) => {
              this.$message.success('收藏成功')
              this.init(this.requestParams)
            })
          })
          .catch(() => {})
      }
    },
    changeTab(x, y) {
      this.activeTab = x
      this.requestParams.category_id = y
      this.init(this.requestParams)
    },
    handleSizeChange(val) {
      this.requestParams.page_size = val
      this.init(this.requestParams)
    },
    handleCurrentChange(val) {
      this.requestParams.page = val
      this.init(this.requestParams)
    },
    handleRouteDto(row) {
      // this.$router.push({
      //   path: `/notes/standard/details`,
      //   query: {
      //     id: row.id
      //   }
      // })
      this.rowId = row.id
      this.dialogVisible = true
    },
    handleRouteDto1(x, v) {
      if (v == 'article_name') {
        this.rowId = x.id
        this.dialogVisible = true
      }
    },
    filterGetData(val) {
      this.requestParams = Object.assign(this.requestParams, val)
      this.init(this.requestParams)
    }
  }
}
</script>

<style scoped lang="scss">
.standard {
  @include fun-layout(1);
  width: $xr-medium-width;
  padding-top: 30px;
  &-tabs {
    &-item {
      width: 100%;
      margin-right: 48px;
      padding: 16px 0;
      background-color: #fff;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      > span {
        font-family: "AdobeHeitiStd-Regular";
        @include fun-design(5);
        > img {
          width: 50px;
          height: 50px;
        }
      }
    }
    > div :nth-child(5) > div {
      margin-right: 0;
    }
    .activeTab {
      @include fun-active(2);
    }
  }
  &-content {
    margin-top: 20px;
    // height: 676px;
    padding: 20px;
    background-color: #fff;
    button {
      color: #666;
      &:hover {
        color: #2f82ff;
      }
    }
  }
}
/deep/.fullscreenDialog{
  .el-dialog__body{
    height: 100%;
    padding-bottom:80px;
    overflow: auto;
  }
}

</style>
